module.exports = __webpack_public_path__ + "assets/BtnMenu.438f77d1.svg";